import { render, staticRenderFns } from "./DialogShare.vue?vue&type=template&id=3d33c360&scoped=true&"
import script from "./DialogShare.vue?vue&type=script&lang=js&"
export * from "./DialogShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33c360",
  null
  
)

export default component.exports